import { Route } from 'react-router'
import { observer } from 'mobx-react-lite'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { UrlShortenerPage } from 'pages/settings/pages/urlShortener/ui/UrlShortenerPage/UrlShortenerPage'

export const UrlShortenerRouter = observer(() => {
  return (
    <RoutesWithNotFound>
      <Route index element={<UrlShortenerPage />} />
    </RoutesWithNotFound>
  )
})
